import React from "react";
import ReactDOM from "react-dom";
import Amplify from "aws-amplify";
import config from "./config";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { ThemeProvider }     from 'styled-components';
import { WhiteLabel }        from "./utils/WhiteLabelProps";
import "./css/Index.css";

WhiteLabel();

// Get saved data from sessionStorage //
var   REACT_APP_COMPANY_LOGO   = sessionStorage.getItem('company_logo'); //WhiteLabel.company_logo;
const REACT_APP_COMPANY_ID     = sessionStorage.getItem('company_id'); //WhiteLabel.company_id;
const REACT_APP_S3_BUCKET_URL  = sessionStorage.getItem('s3_bucket_url');
const REACT_APP_S3_BUCKET_NAME = sessionStorage.getItem('s3_bucket_name');
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

// The regular logo was removed for Posture Health so use a different logo source //
if(REACT_APP_COMPANY_ID === posture_health_company_id)
    REACT_APP_COMPANY_LOGO = "logo_v2.png";

const REACT_APP_COMPANY_LOGO_URL = "https://" + REACT_APP_S3_BUCKET_URL + "/" + REACT_APP_S3_BUCKET_NAME + "/logos/" + REACT_APP_COMPANY_LOGO;

/*
temp remove 1/15/19:
does the below cause this error: "__WEBPACK_IMPORTED_MODULE_4__sigV4Client__.a.newClient(...).signRequest is not a function"*/

Amplify.configure({
    Auth: {
        mandatorySignIn: true,
        region: config.cognito.REGION,
        userPoolId: config.cognito.USER_POOL_ID,
        identityPoolId: config.cognito.IDENTITY_POOL_ID,
        userPoolWebClientId: config.cognito.APP_CLIENT_ID
      },
      Storage: {
        region: config.s3.REGION,
        bucket: config.s3.BUCKET,
        identityPoolId: config.cognito.IDENTITY_POOL_ID
      },
      API: {
        endpoints: [
          {
            name: "ts-app-client",
            endpoint: config.apiGateway.URL,
            region: config.apiGateway.REGION
          },
        ]
    }
});

function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

function transformToAssocArray( prmstr ) {
    var params = {};
    var prmarr = prmstr.split("&");
    for ( var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

//var params = getSearchParameters();
//const cid = params.cid; // 123

var theme = { primary: 'white' };

ReactDOM.render(
    <ThemeProvider theme={ theme }>
        <Router>
          <App logo={REACT_APP_COMPANY_LOGO_URL}
               companyId={REACT_APP_COMPANY_ID}/>
        </Router>
     </ThemeProvider>,
  document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js